import ModifyMemberInfo from './MemberVerifyComplete';

export default ModifyMemberInfo;
